<template>
  <div class="form">
    <p class="message message-error ss-alert" v-if="error">
      {{error.message}}
    </p>
    <Toggle 
      :options="[
        {value: 'fieldtrips_once', label: 'Just once'},
        {value: 'fieldtrips_monthly', label: 'Give monthly'}
      ]"
      name="plan_id"
      v-model="plan_id"
    />
    <div class="amounts">
      <div class="amount" v-for="option in amountOptions">
        <input v-model="currentRadio" :value="option" name="price" :id="option" type="radio">
        <label @click="isCustomChecked=false" class="cm-button" :for="option">${{ option }}</label> 
      </div>

      <div  class="custom-amount">
        <span class="icon">$</span>
        <input :value="customAmount" :checked="isCustomChecked" type="radio" name="price" id="">
        <input v-model="customAmount" @click="isCustomChecked = true" type="text" :placeholder="customAmountPlaceholder">
      </div>
    </div>
    <div id="dropin-container"></div>
    <input type="hidden" name="nonce" ref="nonceInput">
  </div>
</template>

<script>
import Toggle from "../components/toggle.vue"

export default {
  components: {
    Toggle,
  },
  props: {
    braintreeLocale: {
      type: String
    },
    braintreeClientToken: {
      type: String
    }
  },
  data() {
    return {
      amountOptions: [10, 15, 20, 25, 35, 50, 100],
      plan_id: "fieldtrips_monthly",
      error: null,
      isCustomChecked: false,
      customAmount: "",
      currentRadio: Number(window.__DATA__.current_monthly_price) || 50,
      current_monthly_price: window.__DATA__.current_monthly_price
    }
  },
  computed: {
    customAmountPlaceholder() {
      return !this.current_monthly_price || this.amountOptions.includes(Number(this.current_monthly_price)) ? "Other" : this.current_monthly_price
    },
  },
  mounted() {
    const _this = this;
    _this.error = null;
    
    var form = _this.$el.closest("form");
    var button = form.querySelector("input[type=submit]");

    braintree.dropin.create(
      {
        authorization: _this.braintreeClientToken,
        container: "#dropin-container",
        paypal: { flow: "vault" },
        locale: _this.braintreeLocale
      },
      function(createErr, instance) {
        button.addEventListener("click", function(e) {
          e.preventDefault();

          instance.requestPaymentMethod(function(
            requestPaymentMethodErr,
            payload
          ) {
            if (requestPaymentMethodErr) {
              _this.error = requestPaymentMethodErr
              // An appropriate error will be shown in the UI
            } else {
              // Submit payload.nonce to your server
              _this.$refs.nonceInput.value = payload.nonce;
              form.submit();
            }
          });
        });
      }
    );
  },
  
}
</script>

<style lang="scss" scoped>
  .form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-bottom: 1rem;
  }
  .amounts {
    display:  grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1rem;
  }

  .amount {
    input {
      opacity: 0;
      position: absolute;
      &:checked + label {
        background: var(--fg);
        color: var(--bg);
      }
    }

    label {
      background: var(--bg-2);
      color: var(--fg);
      font-size: 1rem;
      width: 100%;
    }
  }

  .custom-amount {
    grid-column: span 2;
    position: relative;

    .icon {
      font-weight: bold;
      position: absolute;
      top: 25%;
      left: 1rem;
      user-select: none;
      z-index: 1;
    }

    input[type=text] {
      border: 1px solid var(--bg-2);
      border-radius: 2rem;
      font-weight: bold;
      padding: 1px 2rem 0 2rem;
      height: 100%;
      width: 100%;
    }

    input[type=radio] {
      opacity: 0;
      position: absolute;

      &:checked + input[type=text] {
        box-shadow: 0 0 0  2px var(--fg);
        outline: 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// app/javascript/components/donation-form.vue?4113c59f